//Header Hub
url = window.location.href;
$('header.hub .site-navigation ul li .nav-link').removeClass('active');
if(window.location.href.indexOf("/declaration") > -1) {
    $('header.hub .site-navigation ul li .nav-link#declaration').addClass('active');
}else if (window.location.href.indexOf("/suivi") > -1) {
    $('header.hub .site-navigation ul li .nav-link#suivi').addClass('active');
}else if (window.location.href.indexOf("/basedoc") > -1) {
    $('header.hub .site-navigation ul li .nav-link#basedoc').addClass('active');
}else if ((window.location.href.indexOf("/demarches") > -1) || (window.location.href.indexOf("/toutes-les-demarches") > -1) ){
    $('header.hub .site-navigation ul li .nav-link#demarches').addClass('active');
}else if (window.location.href.indexOf("/contact") > -1) {
    $('header.hub .site-navigation ul li .nav-link#contact').addClass('active');
}else if (window.location.href.indexOf("/contrat") > -1) {
    $('header.hub .site-navigation ul li .nav-link#contract').addClass('active');
}